import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'ruggedbooks',
      storage,
      whitelist: ['auth', 'user', 'itemsUnderMyName'],
    },
    reducers
  );

  return persistedReducer;
};
